import {BaseContainerModel} from '../../base-container.model';
import {
  bl_fi_entity_hdr_RowClass,
  bl_fi_entity_hdr_RowInterface,
  bl_fi_mst_entity_line_RowInterface,
  bl_fi_mst_entity_login_subject_link_RowClass,
  bl_fi_mst_entity_payment_method_RowInterface,
  bl_fi_mst_branch_employee_link_RowInterface,
  bl_fi_mst_company_employee_link_RowInterface,
} from '../../../dbschema/index';

export class EntityCustomContainer extends BaseContainerModel {
  bl_fi_mst_entity_hdr: bl_fi_entity_hdr_RowInterface = new bl_fi_entity_hdr_RowClass();
  bl_fi_mst_entity_lines: bl_fi_mst_entity_line_RowInterface[] = [];
  bl_fi_mst_entity_payment_methods: bl_fi_mst_entity_payment_method_RowInterface[] = [];
  bl_fi_mst_entity_login_subject_links: bl_fi_mst_entity_login_subject_link_RowClass[] = [];
  bl_fi_mst_branch_employee_links: bl_fi_mst_branch_employee_link_RowInterface[] = [];
  bl_fi_mst_company_employee_links: bl_fi_mst_company_employee_link_RowInterface[] = [];
}
